var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('BaseLoading'):_c('BannerLobForm',{attrs:{"is-loading":_vm.isLoading,"is-edit-mode":true,"is-updating":_vm.isUpdating,"data":_vm.data,"banner-type":_vm.bannerType},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }